export default "__VITE_ASSET__DQy4a44Q__"